import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tablero-transportistas-pending-ssta',
  templateUrl: './tablero-transportistas-pending-ssta.component.html',
  styleUrls: ['./tablero-transportistas-pending-ssta.component.scss']
})
export class TableroTransportistasPendingSstaComponent implements OnInit {

  @Input()
  sstsDataTransportistasPending: any = {}

  programadores: string[] = [];


  @Output()
  eventEmitterUserFilterSearch: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.getDeudas();
  }

  getDeudas() {
    this.programadores = Object.keys(this.sstsDataTransportistasPending.totalPorProgramador);
  }

  searchLocalStorageSsta(user: any, status?: any) {
    this.eventEmitterUserFilterSearch.emit({ user, status })
  }

}
